module.exports = __webpack_public_path__ + "img/SmartRemote_mehrfarbig_RGB_460x311.1b692e62.png";